import { render, staticRenderFns } from "./AskToken.vue?vue&type=template&id=43cb2896&"
import script from "./AskToken.vue?vue&type=script&lang=js&"
export * from "./AskToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports